import { api } from './authService';

export async function getSettings() {
  const { data } = await api.get('/settings');
  return data;
}
export async function updateSettings(body) {
  const { data } = await api.put('/settings', body);
  return data;
}
export async function listUsers() {
  const { data } = await api.get('/users');
  return data;
}
export async function createUser(body) {
  const { data } = await api.post('/users', body);
  return data;
}
export async function updateUser(id, patch) {
  const { data } = await api.patch(`/users/${id}`, patch);
  return data;
}
export async function deleteUser(id) {
  const { data } = await api.delete(`/users/${id}`);
  return data;
}
